'use client';

import React__default from 'react';
import RemoveIcon from '../../Images/RemoveIcon/index.js';
import { AvatarCompany, CompanyInfo as CompanyInfo$1, Title, TextOrg, TextTruncate, CloseBtn } from '../Styled.css.js';

function CompanyInfo(_a) {
    var _b, _c, _d, _e;
    var jobInfo = _a.jobInfo, handleClose = _a.handleClose;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(AvatarCompany, { className: 'head__avatar' },
            React__default.createElement("img", { src: (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.logo) || 'https://images.vietnamworks.com/img/company-default-logo.svg', alt: 'Company logo' })),
        React__default.createElement(CompanyInfo$1, { className: 'head__company' },
            React__default.createElement(Title, null, (_b = jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.title) !== null && _b !== void 0 ? _b : ''),
            React__default.createElement("div", null,
                React__default.createElement("p", null,
                    React__default.createElement(TextOrg, null, (_c = jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.salary) !== null && _c !== void 0 ? _c : ''),
                    " | ",
                    React__default.createElement("span", null, (_d = jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobLevel) !== null && _d !== void 0 ? _d : '')),
                React__default.createElement(TextTruncate, null, (_e = jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.address) !== null && _e !== void 0 ? _e : ''))),
        React__default.createElement(CloseBtn, { onClick: handleClose },
            React__default.createElement(RemoveIcon, null))));
}

export { CompanyInfo as default };
//# sourceMappingURL=CompanyInfo.js.map
